import { render, staticRenderFns } from "./FakeProfileHeartIcon.vue?vue&type=template&id=47283db3&"
import script from "./FakeProfileHeartIcon.vue?vue&type=script&lang=js&"
export * from "./FakeProfileHeartIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports